// 格式化成年-月-日 时:分:秒（去掉毫秒）
export function formatDateTime(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 * 格式化时间：去掉微秒，保留 年月日 时分秒
 * @param {string} timeStr - 如 "2026-04-10 07:54:54.000000"
 * @returns {string} 如 "2026-04-10 07:54:54"
 */
export function formatTimeString(timeStr: string) {
  if (!timeStr) return '';
  // 匹配到小数点前面的所有内容（直接截断微秒）
  return timeStr.split('.')[0] || '';
}

/**
 * 后端时间 → 毫秒时间戳。
 * 支持：毫秒戳（如 1791899759992）、秒戳、日期字符串；无效返回 0。
 * 语义对齐 App `parseDateTimeToUtcTimestamp`（≥1e10 视为毫秒）。
 */
export function parseServerTimeMs(raw?: string | number | null): number {
  if (raw == null || raw === '') return 0;
  if (typeof raw === 'number') {
    if (!Number.isFinite(raw) || raw <= 0) return 0;
    return raw >= 1e10 ? raw : raw * 1000;
  }
  const s = String(raw).trim();
  if (!s) return 0;
  if (/^\d+$/.test(s)) {
    const n = Number(s);
    if (!Number.isFinite(n) || n <= 0) return 0;
    if (s.length >= 13 || n >= 1e10) return n;
    if (s.length === 10 || (n > 1e9 && n < 1e10)) return n * 1000;
  }
  const cleaned = formatTimeString(s);
  if (!cleaned) return 0;
  const t = Date.parse(cleaned.includes('T') ? cleaned : cleaned.replace(' ', 'T'));
  return Number.isFinite(t) ? t : 0;
}

/**
 * 后端时间展示：`YYYY-MM-DD HH:mm:ss`（本地时区）。
 * 入参同 {@link parseServerTimeMs}；无效返回空串。
 */
export function formatServerDateTime(raw?: string | number | null): string {
  const ms = parseServerTimeMs(raw);
  if (!ms) return '';
  return formatDateTime(new Date(ms));
}
